<template>
  <div class="alterpassword">
    <!-- <van-nav-bar title="修改密码" left-text="" fixed  @click-right="onClickRight">
    <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: 25px" @click="goBack"></van-icon>
  </van-nav-bar> -->
    <GlobTopNav title="修改密码"></GlobTopNav>
    <div class="van-content">
      <van-cell-group>
        <van-field
          type="password"
          value=""
          label="当前密码"
          v-model="oldpassword"
          placeholder="请输入当前密码"
        ></van-field>
        <van-field
          type="password"
          value=""
          label="设置新密码"
          v-model="password"
          placeholder="请输入新密码（密码不少于6个字符）"
        ></van-field>
        <van-field
          type="password"
          value=""
          label="确认新密码"
          v-model="repassword"
          placeholder="请再次输入密码"
        ></van-field>
      </van-cell-group>
      <van-cell-group style="background: transparent">
        <van-cell style="background: transparent">
          <van-button size="large" class="save" @click="sendData()"> 确定 </van-button>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "password",
  data() {
    return {
      oldpassword: "",
      password: "",
      repassword: "",
      len: 0
    };
  },
  watch: {
    password: function(newVal, oldVal) {
      this.password = this.password.replace(/\s+/g, "");
    },
    repassword: function(newVal, oldVal) {
      this.repassword = this.repassword.replace(/\s+/g, "");
    }
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      console.log("按钮");
    },
    sendData: function() {
      var mallid = localStorage.getItem("mallid");
      var isUser = localStorage.getItem("BLHuser");
      var reg = new RegExp(/[^\x00-\xff]+$/);
      this.getByteLen(this.password);
      if (!reg.test(this.password)) {
        if (this.len > 5) {
          this.$api.post(
            "user/updatepwd",
            {
              id_example: mallid,
              token_user: isUser,
              opassword: this.oldpassword,
              password: this.password,
              repassword: this.repassword
            },
            res => {
              if (res.data.code == "100") {
                this.$toast("密码已修改成功，请重新登录！");
                localStorage.setItem('isResetting', 0)
                localStorage.removeItem("BLHuser");
                this.$router.push({ name: "NoteLogin" });
                this.$store.commit("userInfo");
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            }
          );
        } else {
          this.$toast("密码不得少于6个字符！");
        }
      } else {
        this.$toast("不能使用汉字或全角字符作为密码");
      }
    },
    getByteLen: function(val) {
      //限制不少于6个字符
      var _this = this;
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i);
        if (a.match(/[^\x00-\xff]/gi) != null) {
          _this.len += 2;
        } else {
          _this.len += 1;
        }
      }
      return _this.len;
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.alterpassword {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;

  .save {
    width: 100%;
    height: 0.96rem;
    background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
    border-radius: 0.48rem;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.42rem;
  }
  .van-cell-group {
    background-color: #fff;

    .van-cell {
      padding: 0.4rem 0.3rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/personal/password.vue